import CheckBoxIcon from '@material-design-icons/svg/outlined/check_box.svg?react';
import CheckBoxOutlineBlankIcon from '@material-design-icons/svg/outlined/check_box_outline_blank.svg?react';
import * as Tabs from '@radix-ui/react-tabs';
import { twMerge } from 'tailwind-merge';

interface Props extends Tabs.TabsTriggerProps {}

export function ProfileTypeToggleButton(props: Props) {
  const { className, children, ...rest } = props;

  return (
    <Tabs.Trigger
      className={twMerge(
        'border-neutral-700',
        'border',
        'fill-neutral-700',
        'group',
        'grid-cols-[max-content_1fr]',
        'grid',
        'items-center',
        'px-4',
        'rounded-lg',
        'text-neutral-700',
        'text-sm',
        'transition-colors',
        'hover:border-white',
        'hover:text-white',
        'hover:fill-white',
        'data-[state=active]:border-white',
        'data-[state=active]:bg-white',
        'data-[state=active]:text-black',
        'data-[state=active]:fill-black',
        className,
      )}
      {...rest}
    >
      <CheckBoxOutlineBlankIcon className="size-4 mr-2 block group-data-[state=active]:hidden" />
      <CheckBoxIcon className="size-4 mr-2 hidden group-data-[state=active]:block" />
      <div className="text-left">{children}</div>
    </Tabs.Trigger>
  );
}
